<div #canvasContainer class="canvasContainer" [class.smooth-visible]="configurationService.isReady && threeService.isReady" [style.background-color]="threeService.nightMode ? threeService.backgroundColorCSS_night : threeService.backgroundColorCSS">
</div>
<!-- <canvas #screenshotContainer width="100" height="100">
</canvas> -->
